module.exports = __webpack_public_path__ + "static/media/b99-bottom-photo.0c984c61.jpg";